<template>
  <a-modal
    title="图标组件编辑"
    :width="900"
    :visible="visible"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭"
    wrapClassName="ant-modal-cust-warp"
    style="top:5%;height: 85%;overflow-y: hidden">

    <!--    <i class="custom-icon"></i>-->
    <a-spin :spinning="confirmLoading">

      <el-tabs v-model="activeName">
        <el-tab-pane label="基础图标" name="defaultIcon">
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="图标颜色">
                <el-color-picker v-model="defaultForm.iconColor" :predefine="predefine"
                                 @change="handleColorChange"></el-color-picker>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="图标大小">
                <el-input-number v-model="defaultForm.iconSize" :min="1"></el-input-number>
              </a-form-item>
            </a-col>
          </a-row>
          <ul class="icon-list">
            <li v-for="(v,i) in defaultIcons" :value="v.iconName" :key="i" @click="selectIcon(v,i)"
                :class="active == i?'selectedStyle':''">
              <i :class="v.iconName" :style="defaultStyle"></i>
            </li>
          </ul>
        </el-tab-pane>
        <el-tab-pane label="自定义图标" name="customIcon">
          <a-row :gutter="24">
            <a-col :span="8">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="图标上传">
                <a-upload
                  class="avatar-uploader"
                  :showUploadList="true"
                  :action="uploadAction"
                  :data="{'isup':1}"
                  :headers="headers"
                  :multiple="true"
                  :beforeUpload="beforeUpload"
                  @change="handleUploadChange"
                >
                  <a-button>
                    <a-icon :type="uploadLoading ? 'loading' : 'upload'" style="margin-top: -20px"/>
                    点我
                  </a-button>
                </a-upload>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="图标名称">
                <el-input v-model="customForm.iconName"></el-input>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="图标大小">
                <el-input-number v-model="customForm.iconSize" :min="1"></el-input-number>
              </a-form-item>
            </a-col>
          </a-row>
          <ul class="icon-list">
            <li v-for="(v,i) in customIcons" :value="v.iconName" :key="i" @click="selectIcon(v,i)"
                :class="active == i?'selectedStyle':''">
              <i :class="v.iconName"></i>
            </li>
          </ul>
        </el-tab-pane>
      </el-tabs>
    </a-spin>
  </a-modal>
</template>

<script>

  import Axios from 'axios'
  import {iconStyle, loadStyleString} from '../js/common'

  const defaultIcons = require('../resource/icons.json');
  export default {
    name: "eleIconSimple",
    props: {
      uploadParam: {
        type: Object,
      }
    },
    data() {
      return {
        style: {},
        headers: {},
        model: {},
        uploadLoading: "",
        activeName: 'defaultIcon',
        conKey: '',
        componentFlag: '',
        active: -1,
        defaultIcons: [],
        customIcons: [],
        visible: false,
        confirmLoading: false,
        selectColor: {color: '#99a9bf'},
        defaultForm: {
          type: '1',
          iconColor: '#99a9bf',
          iconSize: 18
        },
        customForm: {
          type: '2',
          path: "",
          iconSize: 18
        },
        predefine: [
          'rgba(30, 144, 255, 1)',
          'rgba(144, 238, 144, 1)',
          'rgba(255, 215, 0, 1)',
        ],
        labelCol: {
          xs: {span: 24},
          sm: {span: 8},
        },
        wrapperCol: {
          xs: {span: 24},
          sm: {span: 12},
        },
      }
    },
    mounted() {
      this.headers = {"X-Access-Token": this.uploadParam.accessToken}
    },
    watch: {
      customIcons: {
        handler(vals) {
          this.initCustomerStyle(vals);
        }
      }
    },
    computed: {
      iconStyle: function () {
        iconStyle({path: this.path, iconSize: this.iconSize})
      },
      uploadAction: function () {
        return this.uploadParam.fileUpload;
      },
      defaultStyle: function () {
        return {color: this.defaultForm.iconColor, 'font-size': `${this.defaultForm.iconSize}px`};
      }
    },
    methods: {
      edit(conKey, componentFlag) {
        Axios.get('/mes/sys/componentDataHandle/getCustomIconData',
          {headers: {'X-Access-Token': this.uploadParam.accessToken}}).then(res => {
          if (res.data.success) {
            this.customIcons = res.data.result;
          }
        });

        this.visible = true;
        this.defaultIcons = defaultIcons;
        this.conKey = conKey;
        this.componentFlag = componentFlag;
      },
      handleOk() {
        this.visible = false;
        this.$emit('setComponentData',
          JSON.stringify(
            this.activeName == 'defaultIcon' ? Object.assign(this.defaultForm,
              {iconName: this.defaultIcons[this.active].iconName}) : this.customForm),
          this.conKey,
          this.componentFlag);
      },
      handleCancel() {
        this.visible = false;
      },
      handleColorChange(val_) {
        this.selectColor = {color: val_};
      },
      selectIcon(v, i) {
        if (this.activeName == 'customIcon') {
          this.customForm = v
        }
        this.active = i;
      },
      beforeUpload: function (file) {
        let fileType = file.type;
        if (fileType.indexOf('image') < 0) {
          this.$message.warning('请上传图片');
          return false;
        }
      },
      handleUploadChange(info) {
        if (info.file.status === 'uploading') {
          this.uploadLoading = true;
          return
        }
        if (info.file.status === 'done') {
          let response = info.file.response;
          this.uploadLoading = false;
          if (response.success) {
            this.model.avatar = response.message;
            this.customForm.path = this.uploadParam.imgerver + "/" + this.model.avatar;
          } else {
            this.$message.warning(response.message);
          }
        }
      },
      initCustomerStyle(styles) {
        styles.forEach(style => {
          loadStyleString(iconStyle(style));
        });
      }
    }
  }
</script>
<style scoped>
  .selectedStyle {
    background-color: #B0C4DE;
  }

  li {
    display: list-item;
    text-align: -webkit-match-parent;
  }

  .icon-list {
    overflow: hidden;
    list-style: none;
    padding: 0 !important;
    border: 1px solid #eaeefb;
    border-radius: 4px;
  }

  .icon-list li i {
    display: block;
    font-size: 32px;
    color: #606266;
    transition: color .15s linear;
  }

  li > i {
    padding-top: 40%;
  }

  .icon-list li {
    float: left;
    width: 16.66%;
    text-align: center;
    height: 120px;
    line-height: 120px;
    font-size: 13px;
    border-right: 1px solid #eee;
    border-bottom: 1px solid #eee;
    margin-right: -1px;
    margin-bottom: -1px;
  }
</style>



// WEBPACK FOOTER //
// src/lib/editMoudle/eleIconSimple.vue